import avatarIcon from '../assets/pricing/avatar-icon.svg';
import brollIcon from '../assets/pricing/broll-icon.svg';
import logoIcon from '../assets/pricing/logo-icon.svg';
import multilanguageIcon from '../assets/pricing/multilanguage-icon.svg';
import shareIcon from '../assets/pricing/share-icon.svg';
import supportIcon from '../assets/pricing/support-icon.svg';
import timeIcon from '../assets/pricing/time-icon.svg';
import aiIcon from '../assets/pricing/ai-icon.svg';

const pricingData = {
  header: {
    heading: 'Simple Pricing That Scales With You',
    description: 'Turn PPTs into professional videos in minutes with CourseCut AI.'
  },

  plans: [
    {
      id: 1,
      name: 'Free',
      price: null,
      billingPeriod: null,
      creditsText: '0 CREDITS PER YEAR',
      buttonText: 'Get started',
      buttonLink: `${window.location.origin}/Dashboard`,
      isComingSoon: false,
      customizable: false,
      features: [
        {
          icon: timeIcon,
          text: "<span class='highlight'>1 free</span> watermarked video",
          available: true
        },
        {
          icon: aiIcon,
          lines: ['AI generated first draft script', 'Fully editable'],
          available: true
        },
        {
          icon: avatarIcon,
          lines: ['Stock AI avatars', 'Custom AI avatars'],
          available: true
        },
        {
          icon: brollIcon,
          lines: [
            'Premium B-roll footage',
            'Premium background music',
            'Smart, attention-guided animations'
          ],
          available: true
        },
        {
          icon: logoIcon,
          text: 'Upload your brand logo',
          available: true
        },
        {
          icon: shareIcon,
          text: 'Shareable video links',
          available: true
        }
      ]
    },
    {
      id: 2,
      name: '$100',
      price: 100,
      billingPeriod: '/year, billed yearly',
      creditsText: 'Customizable yearly usage',
      creditsOptions: [
        { credits: 10000, label: '10,000 CREDITS /Y', price: 100, priceINR: 7500, minutes: 166 },
        { credits: 20000, label: '20,000 CREDITS /Y', price: 200, priceINR: 15000, minutes: 333 },
        { credits: 30000, label: '30,000 CREDITS /Y', price: 300, priceINR: 22500, minutes: 500 },
        { credits: 40000, label: '40,000 CREDITS /Y', price: 400, priceINR: 30000, minutes: 666 },
        { credits: 50000, label: '50,000 CREDITS /Y', price: 500, priceINR: 37500, minutes: 833 },
        { credits: 60000, label: '60,000 CREDITS /Y', price: 600, priceINR: 45000, minutes: 1000 },
        { credits: 70000, label: '70,000 CREDITS /Y', price: 700, priceINR: 52500, minutes: 1166 },
        { credits: 80000, label: '80,000 CREDITS /Y', price: 800, priceINR: 60000, minutes: 1333 },
        { credits: 90000, label: '90,000 CREDITS /Y', price: 900, priceINR: 67500, minutes: 1500 },
        {
          credits: 100000,
          label: '1,00,000 CREDITS /Y',
          price: 1000,
          priceINR: 75000,
          minutes: 1666
        }
      ],
      buttonText: 'Get Started',
      buttonLink: '#',
      isComingSoon: false,
      customizable: true,
      features: [
        {
          icon: timeIcon,
          lines: ["<span class='highlight'>10,000</span> Credits"],
          available: true,
          isDynamic: true
        },
        {
          icon: aiIcon,
          lines: ['AI generated first draft script', 'Fully editable'],
          available: true
        },
        {
          icon: avatarIcon,
          lines: ['Stock AI avatars', 'Custom AI avatars'],
          available: true
        },
        {
          icon: brollIcon,
          lines: [
            'Premium B-roll footage',
            'Premium background music',
            'Smart, attention-guided animations'
          ],
          available: true
        },
        {
          icon: logoIcon,
          lines: ['Upload your brand logo', 'Remove CourseCut watermark'],
          available: true
        },
        {
          icon: multilanguageIcon,
          text: 'Multilingual translation',
          available: true
        },
        {
          icon: shareIcon,
          lines: ['Shareable video links', 'Download videos in MP4 format'],
          available: true
        }
      ]
    },
    {
      id: 3,
      name: '$1000',
      price: 1000,
      pricePrefix: 'Starts ',
      billingPeriod: '/year, billed yearly',
      creditsText: 'Customizable yearly usage',
      buttonText: 'Contact Sales',
      buttonLink: 'mailto:support@coursecut.ai',
      isComingSoon: false,
      customizable: true,
      features: [
        {
          icon: timeIcon,
          text: 'CUSTOM CREDITS',
          available: true
        },
        {
          icon: aiIcon,
          lines: ['AI generated first draft script', 'Fully editable'],
          available: true
        },
        {
          icon: avatarIcon,
          lines: ['Stock AI avatars', 'Custom AI avatars'],
          available: true
        },
        {
          icon: brollIcon,
          lines: [
            'Premium B-roll footage',
            'Premium background music',
            'Smart, attention-guided animations'
          ],
          available: true
        },
        {
          icon: logoIcon,
          lines: ['Upload your brand logo', 'Remove CourseCut watermark'],
          available: true
        },
        {
          icon: multilanguageIcon,
          text: 'Multilingual translation',
          available: true
        },
        {
          icon: shareIcon,
          lines: [
            'Shareable video links',
            'Download videos in MP4 format',
            'Export timelines to Premiere (.xml) and Final Cut Pro X (fcpxml)'
          ],
          available: true
        },
        {
          icon: supportIcon,
          text: 'Priority support',
          available: true
        }
      ]
    }
  ],

  seoContent: {
    title: 'CourseCut AI Pricing | Turn PPTs into Videos',
    description:
      'Simple, credit-based pricing to turn PPTs into professional videos with CourseCut AI. Annual plans designed to scale with your needs.'
  }
};

export default pricingData;
